import { useCustomQuery } from '../../graphql';

interface FindAssignableWorkspacesFilter {
  featureId: string;
  assignments?: string[];
  keyword?: string;
}

interface PageRequest {
  offset?: number;
  limit?: number;
}

export const FIND_FEATURE_ASSIGNABLE_WORKSPACES = `
  query FindAssignableWorkspaces(
    $filter: FindAssignableWorkspacesFilter!
    $page: PageRequest
    $orderBy: OrderByInput
  ) {
    feature {
      findAssignableWorkspaces(filter: $filter, page: $page, orderBy: $orderBy) {
        items {
          id
          name
        }
        count
        offset
        limit
      }
    }
  }
`;

export const useFindAssignableWorkspaces = (
  filter: FindAssignableWorkspacesFilter,
  page?: PageRequest
) => {
  const { data, isPending } = useCustomQuery({
    query: FIND_FEATURE_ASSIGNABLE_WORKSPACES,
    cacheKey: [
      'feature',
      'assignable-workspaces',
      filter.featureId,
      filter.keyword,
    ],
    variables: { filter, page },
  });

  return { data, isPending };
};
